import color from "@constants/color";
import React, { useState } from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import CustomPicker from "@components/CustomDropdownPicker/Picker";

interface ReturnReasonDropdownProps {
  value: any;
  setValue: any;
  items: any;
  setItems: any;
}
const ReturnReasonDropdown: React.FC<ReturnReasonDropdownProps> = ({
  value,
  setValue,
  items,
  setItems,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <View style={styles.container}>
      <Text variant="body_text_4" style={styles.title}>
        ऑर्डर डिलीवर ना करने का कारण क्या है ?
      </Text>
      <CustomPicker
        schema={{
          label: "value",
          value: "key",
        }}
        open={open}
        value={value}
        items={items}
        setOpen={setOpen}
        setValue={setValue}
        setItems={setItems}
        placeholder="कारण सेलेक्ट करें"
        style={styles.dropdown}
        textStyle={styles.textStyle}
      />
    </View>
  );
};

export default ReturnReasonDropdown;

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: color.mediumBlack,
    flex: 1,
    marginHorizontal: 12,
    borderRadius: 16,
    zIndex: 100,
  },
  title: {
    marginBottom: 8,
    color: color.white,
  },
  dropdown: {
    borderWidth: 1,
    borderColor: color.white,
    borderRadius: 8,
    height: 50,
  },
  textStyle: {
    fontSize: 14,
    color: color.mediumBlack,
  },
});
